import { Expose } from "class-transformer";
import { IsNumber, IsString, IsArray } from "class-validator";

export class WorkFlowItemModel {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  params!: string;
  @IsNumber()
  @Expose()
  state!: number;
  @IsString()
  @Expose()
  type!: string;
  @IsArray()
  @Expose()
  parents!: Array<number>;
  @IsArray()
  @Expose()
  children!: Array<number>;
}
